export default __webpack_public_path__ + "static/media/minimalinv-banner-mob.9bc2ad08.jpg";